<div class="datetime-filter p-2">
  <select class="form-select form-select-sm mb-2" [(ngModel)]="filterType">
    <option *ngFor="let opt of filterOptions" [value]="opt.value">{{ opt.label }}</option>
  </select>

  <small *ngIf="filterType === 'inRange'" class="text-muted">From</small>
  <div class="mb-2">
    <input type="date" class="form-control form-control-sm" [(ngModel)]="date">
  </div>

  <div *ngIf="filterType === 'inRange'" class="d-flex flex-column gap-1 mb-2">
    <small class="text-muted">To</small>
    <input type="date" class="form-control form-control-sm" [(ngModel)]="dateTo">
  </div>

  <div class="d-flex gap-2">
    <button class="btn btn-primary btn-sm flex-fill" (click)="applyFilter()">Apply</button>
    <button class="btn btn-outline-secondary btn-sm flex-fill" (click)="clearFilter()">Clear</button>
  </div>
</div>
